/**
 * Composition root for push notifications no app cliente web.
 *
 * Mirror dos `DefaultAppDependencies.pushNotificationsService` no iOS /
 * Android + do `lib/push.ts` no fields-system-web. Wires:
 *
 *   - Provider: `FirebaseMessagingProvider` do `@meiuca/firebase` (a app
 *     Firebase em si é inicializada por `lib/firebase.ts`, importado
 *     antes deste módulo via `App.tsx` / `index.tsx`).
 *   - Registrar: adapter local em
 *     `services/pushSubscriptionRegistrar.ts`, autenticado contra
 *     `MobileAppApi`.
 *   - Device id: UUID estável em `localStorage`.
 *
 * Lifecycle (mesmo padrão iOS/Android):
 *   1. `prepare()` no boot do app (`index.tsx`) — captura token, registra
 *      anonimamente quando ainda não há sessão.
 *   2. `enableBackendRegistration()` após login bem sucedido (registered
 *      via `config/setupPushLifecycle.tsx` no AuthContext).
 *   3. `disableBackendRegistration()` no logout — no-op nesta fatia.
 */

import { FirebaseMessagingProvider } from '@meiuca/firebase'
import { PushNotificationsService } from '@meiuca/push'

import { getOrCreatePushDeviceId } from './pushDeviceId'
import { pushSubscriptionRegistrar } from '@/services/pushSubscriptionRegistrar'
// Garante que `initializeFirebaseApp(...)` rode antes do provider tentar
// usar `getMessaging()` — `lib/firebase.ts` faz a init no momento do
// import como side effect.
import '@/lib/firebase'

const firebaseProvider = new FirebaseMessagingProvider({
  vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
})

export const pushNotificationsService = new PushNotificationsService({
  provider: firebaseProvider,
  registrar: pushSubscriptionRegistrar,
  deviceIdentifierProvider: () => getOrCreatePushDeviceId(),
})
